module.exports = __webpack_public_path__ + "static/media/mv01.39eb2ba7.jpg";